// types
import type { IVehicle } from '@makemydeal/dr-platform-types';
import { VehicleListRowItemNotInStock } from './VehicleListRowItemNotInStock';
import { VehicleListRowItemInStockCompact } from './vehicleListRowItemInStock/compact/VehicleListRowItemInStockCompact';
import type { CatalogVehicleWithIndex } from '../../types';

export type VehicleListRowItemProps = {
    vehicle: CatalogVehicleWithIndex;
    redirectToBuildVehicleTab: (vehicle: IVehicle) => void;
};

export const VehicleListRowItemInterstate = ({ vehicle, redirectToBuildVehicleTab }: VehicleListRowItemProps) => {
    const { stockNumber } = vehicle;

    return !stockNumber ? (
        <VehicleListRowItemNotInStock vehicle={vehicle} onBuildVehicleClick={redirectToBuildVehicleTab} />
    ) : (
        <VehicleListRowItemInStockCompact vehicle={vehicle} />
    );
};
